import MonthlyHR from "./MonthlyHR";

export default function SalaryProcessing() {
  return <MonthlyHR kind="payroll" />;
}
